import type { ListBuilderList } from '../../../types';

/**
 * Expiring Soon list - active licenses approaching expiration.
 *
 * This is the renewal queue for compliance officers. Defaults to showing
 * licenses expiring within the next 30 days — same window the compliance
 * dashboard "Expiring Soon" KPI uses, so the click-through count matches
 * the KPI value. The expiration-date filter remains visible and editable
 * for officers who want to widen or narrow the window.
 */
export const expiringSoonList: ListBuilderList = {
	id: 'default-licenses-expiring-soon',
	cacheTTL: 300000,
	name: 'Expiring Soon',
	type: 'default',
	active: true,
	sortOrder: 2,
	filterRules: {
		licenseStatus: {
			defaultValue: [{ id: 'Active', label: 'Active' }],
			locked: true,
			hidden: true,
		},
		licenseExpirationDateRange: {
			defaultValue: [
				{
					id: 'next30days',
					label: 'Next 30 Days',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:+30d}}',
					},
				},
			],
		},
	},
	inheritsFrom: 'default-licenses-all',
};
